import { Component, ElementRef, inject, Renderer2, ViewEncapsulation, input, effect } from '@angular/core';
import { NgClass } from '@angular/common';

/**
 * @deprecated - Will be removed with the Angular 23 migration.
 * Use the [CSS Grid](https://designsystem.acc.aws.devolksbank.net/index.html?path=/docs/components-style-grid--docs)
 * in ap/style instead
 */
@Component({
    selector: 'ap-grid-row',
    templateUrl: './row.component.html',
    styleUrls: ['./row.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [NgClass],
    host: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[class.ap-grid-row__full-bleed]': 'this.apFullBleed()'
    }
})
export class ApRowComponent {
    private readonly renderer = inject(Renderer2);
    private readonly hostElement = inject(ElementRef);

    /**
     * Whether to render the row without gutters.
     * Defaults to `false`.
     */
    public readonly noGutter = input(false);

    /**
     * Whether grid needs to be rendered as full bleed stylings.
     * Defaults to `false`.
     */
    public readonly apFullBleed = input(false);

    /**
     * Whether top padding should be added.
     * This will only be set if `apFullBleed` is also true.
     * If `apFullBleed` is false this property does nothing
     * Defaults to `false`.
     */
    public readonly topPadding = input(false);

    /**
     * Whether bottom margin should be added.
     * This will only be set if `apFullBleed` is also true.
     * If `apFullBleed` is false this property does nothing
     * Defaults to `false`.
     */
    public readonly bottomMargin = input(true);

    /**
     * Dynamically set margin bottom based on full bleed property
     */
    constructor() {
        effect(() => {
            this.setTopPadding();
            this.setBottomMargin();
        });
    }

    /**
     * Set top padding based on apFullBleed
     */
    private setTopPadding(): void {
        if (this.apFullBleed() && this.topPadding()) {
            this.renderer.addClass(this.hostElement.nativeElement, 'ap-grid-row__full-bleed--top-padding');
        } else {
            this.renderer.removeClass(this.hostElement.nativeElement, 'ap-grid-row__full-bleed--top-padding');
        }
    }

    /**
     * Set bottom margin based on apFullBleed
     */
    private setBottomMargin(): void {
        if (this.apFullBleed() && !this.bottomMargin()) {
            this.renderer.addClass(this.hostElement.nativeElement, 'ap-grid-row__full-bleed--no-bottom-margin');
        } else {
            this.renderer.removeClass(this.hostElement.nativeElement, 'ap-grid-row__full-bleed--no-bottom-margin');
        }
    }
}
